import { useState, useRef, useEffect } from "react";

export const CustomMultiSelect = ({
  input,
  options,
  label,
  required,
  meta: { touched, error },
  disabled,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const dropdownRef = useRef(null);
  const chooseItemOption = options.find(
    (opt) => opt.value === "Choose an item."
  );

  // Initialize selected options
  useEffect(() => {
    if (input.value && Array.isArray(input.value)) {
      // Jika ada nilai yang dipilih, tampilkan yang dipilih
      const selected = options.filter((opt) => input.value.includes(opt.value));
      setSelectedOptions(selected);
    } else {
      // Jika tidak ada yang dipilih, set default "Choose an item."
      setSelectedOptions(chooseItemOption ? [chooseItemOption] : []);
      input.onChange(chooseItemOption ? ["Choose an item."] : []);
    }
  }, [input.value, options]);

  // Toggle selection
  const toggleOption = (option) => {
    let newSelection = [];

    if (option.value === "Choose an item.") {
      // Jika memilih "Choose an item.", hapus semua pilihan lain
      newSelection = [option];
    } else {
      // Hapus "Choose an item." jika ada pilihan lain
      newSelection = selectedOptions.filter(
        (item) => item.value !== "Choose an item."
      );

      // Toggle pilihan yang diklik
      const isSelected = selectedOptions.some(
        (item) => item.value === option.value
      );
      if (isSelected) {
        newSelection = newSelection.filter(
          (item) => item.value !== option.value
        );
      } else {
        newSelection = [...newSelection, option];
      }

      // Jika tidak ada yang dipilih, tambahkan "Choose an item."
      if (newSelection.length === 0 && chooseItemOption) {
        newSelection = [chooseItemOption];
      }
    }

    setSelectedOptions(newSelection);
    input.onChange(newSelection.map((opt) => opt.value));
  };

  // Render options
  const renderOptions = options.map((option) => {
    const isChooseItem = option.value === "Choose an item.";
    const isSelected = selectedOptions.some(
      (item) => item.value === option.value
    );

    return (
      <div
        key={option.value}
        className="dropdown-item"
        onClick={() => !disabled && toggleOption(option)}
        style={{
          padding: "8px 12px",
          cursor: disabled ? "not-allowed" : "pointer",
          backgroundColor: isSelected ? "#f8f9fa" : "transparent",
          ...(isChooseItem && {
            fontStyle: "italic",
            color: "#6c757d",
          }),
        }}
      >
        {!isChooseItem && (
          <input
            type="checkbox"
            checked={isSelected}
            onChange={() => {}}
            style={{ marginRight: "8px" }}
          />
        )}
        {option.label}
      </div>
    );
  });

  return (
    <div className={`form-group ${input.name.split(".").join("_")}`}>
      <label className="col-sm-3 control-label">
        {label} {required && <span style={{ color: "red" }}>*</span>}
      </label>
      <div className="col-sm-9">
        <div className="custom-multiselect" ref={dropdownRef}>
          {/* Selected items display */}
          <div
            className="multiselect-input"
            onClick={() => !disabled && setIsOpen(!isOpen)}
            style={{
              border: `1px solid ${touched && error ? "red" : "#ccc"}`,
              borderRadius: "4px",
              padding: "5px",
              minHeight: "38px",
              cursor: disabled ? "not-allowed" : "pointer",
              backgroundColor: disabled ? "#e9ecef" : "#fff",
            }}
          >
            {selectedOptions.length > 0 ? (
              <div
                className="selected-items"
                style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}
              >
                {selectedOptions.map((option) => (
                  <div
                    key={option.value}
                    className="selected-item"
                    style={{
                      backgroundColor:
                        option.value === "Choose an item."
                          ? "transparent"
                          : "#e4e4e4",
                      borderRadius: "3px",
                      padding: "2px 8px",
                      margin: "2px",
                      display: "flex",
                      alignItems: "center",
                      fontStyle:
                        option.value === "Choose an item."
                          ? "italic"
                          : "normal",
                      color:
                        option.value === "Choose an item."
                          ? "#6c757d"
                          : "inherit",
                    }}
                  >
                    <span>{option.label}</span>
                    {!disabled && option.value !== "Choose an item." && (
                      <span
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleOption(option);
                        }}
                        style={{
                          marginLeft: "5px",
                          cursor: "pointer",
                          fontSize: "14px",
                        }}
                      >
                        ×
                      </span>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <div className="placeholder" style={{ color: "#6c757d" }}>
                Select...
              </div>
            )}
          </div>

          {/* Dropdown options */}
          {isOpen && !disabled && (
            <div
              className="dropdown-menu"
              style={{
                display: "block",
                position: "absolute",
                width: "100%",
                maxHeight: "200px",
                overflowY: "auto",
                zIndex: 1000,
                border: "1px solid rgba(0,0,0,.15)",
                borderRadius: "4px",
                padding: "5px 0",
                backgroundColor: "#fff",
                boxShadow: "0 6px 12px rgba(0,0,0,.175)",
              }}
            >
              {renderOptions}
            </div>
          )}
        </div>
        {touched && error && <div className="alert alert-danger">{error}</div>}
      </div>
    </div>
  );
};
